<template>
  <div>
    <div :class="['cart-item mb-10 mx-0', { 'px-0': isMobile, 'border-bottom-0': index === brandBranches.length - 1 }]"
      v-for="(brandBranch, index) in brandBranch" :key="index">
      <h2
        :class="['d-flex justify-content-between fw-bold py-0 mb-0 bg-white', { 'px-4 mx-1': !isMobile, 'px-3': isMobile }]"
        v-if="cart.list.length > 1">
        {{ brandBranch.brand }} ({{ brandBranch.branch }})
      </h2>
      <FulfillmentComponent v-if="!isMobile && showFulfillment && isBranchDetailsDataLoaded && brandBranch.details"
        :isBranchDetailsDataLoaded="isBranchDetailsDataLoaded" :brandBranch="brandBranch"
        :index="index" cssClass="pb-3 border-bottom mt-3 mx-0 px-3" @selectBranchLogisticType="selectBranchLogisticType"
        @showScheduleModal="showScheduleModal" />
      <div :class="['mt-3', { 'px-3 mx-3': !isMobile }]" v-for="(order, oindex) in formattedOrders" :key="oindex">
        <div :class="['d-flex', { 'px-3': isMobile }]" no-gutters v-if="
          order.branch == brandBranch.branch &&
          order.brand == brandBranch.brand
        ">
          <div class="mr-3 cart-item-image" v-if="!isMobile">
            <img :src="order.image" style="max-width: 100%" alt="Order Item" />
          </div>
          <div class="aCenter cart-count mr-3">
            <label for="order-quantity" class="fw-bold px-2 py-1" v-if="webDesign !== null && webDesign.design !== null"
              :style="{
                backgroundColor: webDesign.design.main_color + '1F',
                color: webDesign.design.main_color
              }">
              {{ parseInt(order.quantity) }}x
            </label>
          </div>
          <div class="cart-desc flex-grow-1">
            <p class="text-break pb-0 mb-0 fw-bold">{{ order.name }}</p>
            <span v-show="order.product_type == 'variable'" v-html="formatAttribute(order.decoded_variation)"></span>
            <span v-if="order.add_ons.length > 0">
              {{ order.add_ons.map((addon) => addon.name).join(" + ") }}
            </span>
            <span class="text-break" v-if="order.remarks">
              Notes: {{ order.remarks }}
            </span>
            <div class="d-flex mb-10 mt-2">
              <div class="edit-item mr-2">
                <b-button type="button" v-if="webDesign !== null && webDesign.design !== null" :style="{
                  borderColor: webDesign.design.main_color,
                  color: webDesign.design.main_color
                }" style="
                    padding: 3px !important; 
                    background-color: transparent !important;
                    border-radius: 31px !important;" :id="'cart-edit-' + oindex" @click="$emit('showModal',
                      order.branch_uuid, order.product_uuid, order.item_uuid, order.stock, order.is_limited_stock)">
                  Edit
                </b-button>
                <b-button type=" button" v-else :style="{
                  borderColor: webDesign.design.main_color,
                  color: webDesign.design.main_color
                }" style="
                    padding: 3px !important; 
                    background-color: transparent !important;
                    border-radius: 31px !important;" :id="'cart-edit-' + oindex" @click="
                      showModal(
                        order.branch_uuid,
                        order.product_uuid,
                        order.item_uuid,
                        order.stock,
                        order.is_limited_stock
                      )
                      ">
                  Edit
                </b-button>
              </div>
              <div class="remove-item position-relative">
                <b-button type="button" class="btn" style="
                    padding: 3px !important; 
                    border-radius: 33px !important;
                    border-color: #1E1E1E !important;
                    color: #1E1E1E !important;
                    background-color: transparent !important;
                  " @click="$emit('confirmRemove', oindex)">
                  Remove
                </b-button>
                <div class="remove-confirmation" v-show="order.visible">
                  <label for="remove-item">Remove this item?</label>
                  <ul>
                    <li @click="$emit('removeItem', order.item_uuid, oindex)">Yes</li>
                    <li @click="$emit('confirmRemove', oindex)">No</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="cart-price text-right fw-bold" style="height: 10px">
            &#8369; {{ putComma(Number(order.total_amount).toFixed(2)) }}
          </div>
        </div>
      </div>
      <div :class="['d-flex align-items-center justify-content-between', { 'mx-4': !isMobile, 'px-3': isMobile }]">
        <div class="add-items flex-grow-1" v-show="source != 'navbar'"
          v-if="webDesign !== null && webDesign.design !== null" :style="{ color: webDesign.design.main_color }"
          @click="$emit('addMoreItems', brandBranch.branch_uuid, brandBranch.brand_uuid)">
          <span @click="$root.$emit('toggleCartIfOpened')" style="cursor: pointer;">+ Add more items</span>
        </div>
        <ClearCartComponent :webDesign="webDesign" :source="source" @confirmRemoveAll="$emit('confirmRemoveAll')"
          v-if="isMobile && brandBranches.length === 1" />
      </div>
      <FulfillmentComponent v-if="isMobile && showFulfillment && isBranchDetailsDataLoaded && brandBranch.details"
        :isBranchDetailsDataLoaded="isBranchDetailsDataLoaded" :brandBranch="brandBranch"
        :index="index" cssClass="pt-3 border-top mb-3 mx-0" @selectBranchLogisticType="selectBranchLogisticType"
        @showScheduleModal="showScheduleModal" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ClearCartComponent from "./ClearCartComponent.vue";
import FulfillmentComponent from "./FulfillmentComponent.vue";

export default {
  props: [
    "brandBranches",
    "brandBranch",
    "cart",
    "showFulfillment",
    "isBranchDetailsDataLoaded",
    "formattedOrders",
    "source"
  ],
  components: { ClearCartComponent, FulfillmentComponent },
  computed: {
    ...mapState("estore", {
      webDesign: (state) => state.webDesign
    }),
    ...mapGetters({
      isMobile: "isMobile/isMobile"
    })
  },
  methods: {
    formatAttribute(decoded_variation) {
      let variations = decoded_variation.map(function (obj) {
        return obj.attribute + " - " + obj.value;
      });

      return variations.join("<br/>");
    },
    putComma(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    selectBranchLogisticType(brandBranch, key, index) {
      this.$emit("selectBranchLogisticType", brandBranch, key, index);
    },
    showScheduleModal(brandBranch) {
      this.$emit("showScheduleModal", brandBranch);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/views/cart/_base.scss";

.cart-item-image {
  max-width: 70px;
}

.add-items {
  font-size: 16px;
  margin: 23px 0;
}

.add-items span {
  @extend .mainFontBold;
}

.edit-item button,
.remove-item button {
  min-width: 80px;
  font-size: 12px;
  @extend .mainFontBold;
}

.cart-count label {
  border-radius: 20%;
}
</style>
